// ─── components/UI/VerifiedSchoolChip.jsx ──────────────────────────────────
// "✓ Oregon State verified", worn in the school's own colours. Replaces the
// generic "University verified" chip everywhere a person's affiliation shows,
// so the trust signal names the school instead of the platform.
//
// Colours come from universityBadge(), which darkens a school colour until it
// clears WCAG AA on the surface it sits on (OSU orange is only 4.3:1 raw).
import React from 'react';
import PropTypes from 'prop-types';
import { PiSealCheckFill } from 'react-icons/pi';
import { universityBadge } from '../../pages/Social/universityTheme';

// "Oregon State University" → "Oregon State". "University of Oregon" stays as is.
export function shortSchoolName(name = '') {
  return name.trim().replace(/^The\s+/i, '').replace(/\s+University$/i, '');
}

export default function VerifiedSchoolChip({ university, verified = true, surface, className = '' }) {
  if (!university && !verified) return null;
  const badge = university ? universityBadge(university, surface) : null;
  const name = university ? shortSchoolName(university) : 'University';
  return (
    <span
      title={university || undefined}
      className={`inline-flex max-w-full items-center gap-1.5 rounded-full px-3 py-1 text-[12px] font-semibold ${
        badge ? '' : 'bg-press-soft text-press-ink'
      } ${className}`}
      style={badge ? { background: badge.tint, color: badge.ink, boxShadow: `inset 0 0 0 1px ${badge.edge}` } : undefined}
    >
      {verified && <PiSealCheckFill size={14} className="flex-none" aria-hidden="true" />}
      <span className="truncate">{verified ? `${name} verified` : name}</span>
    </span>
  );
}

VerifiedSchoolChip.propTypes = {
  university: PropTypes.string,
  verified: PropTypes.bool,
  surface: PropTypes.string,
  className: PropTypes.string,
};
